module.exports = new __parcel__URL__("pve_continue_button.8880205a.png").toString();